import { render, staticRenderFns } from "./purchase-table-dialog.vue?vue&type=template&id=13ab0e05&scoped=true&"
import script from "./purchase-table-dialog.vue?vue&type=script&lang=js&"
export * from "./purchase-table-dialog.vue?vue&type=script&lang=js&"
import style0 from "./purchase-table-dialog.vue?vue&type=style&index=0&id=13ab0e05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ab0e05",
  null
  
)

export default component.exports